<!-- @veltra/icons generated sha256:e00484cfbbb8b595 gen:8 source:src/svg/normal/monitor.svg -->
<script setup lang="ts">
defineOptions({ name: 'Monitor' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M2.5 11h4.504c.276 0 .496.234.496.51v.98c0 .277-.22.51-.495.51h-3.51a.5.5 0 0 0 .003 1h9.005a.501.501 0 0 0 .002-1h-3.51a.504.504 0 0 1-.495-.51v-.98c0-.276.22-.51.496-.51H13.5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-11a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1m0-8h11v7h-11z"
    />
  </svg>
</template>
